import { Component, Input, OnChanges } from '@angular/core';

// The dashboard's stat card (icon, big value + small unit, muted label) as a
// reusable piece. Give it either an `icon` image path or an `iconClass`
// (remixicon), and either a split `value` + `unit` or a pre-formatted string
// in `value` — "227.00 million PKR" is split into "227.00" and "million PKR".
// Set `custom` to show projected content (e.g. badges) in place of the value.
@Component({
    selector: 'app-stat-card',
    templateUrl: './stat-card.component.html',
    styleUrls: ['./stat-card.component.scss']
})
export class StatCardComponent implements OnChanges {
    @Input() icon: string;
    @Input() iconClass: string;
    @Input() label: string;
    @Input() value: string | number | null | undefined;
    @Input() unit: string;
    @Input() valueClass: string;
    @Input() custom = false;

    parts = { value: '—', unit: '' };

    // Same particle burst as the dashboard cards (animation.scss).
    readonly particles = [
        [44, 0], [38, 20], [22, 37], [0, 43], [-22, 37], [-38, 20], [-44, 0],
        [-38, -20], [-22, -37], [0, -43], [22, -37], [38, -20], [32, 32], [-32, -32]
    ];

    ngOnChanges(): void {
        this.parts = StatCardComponent.split(this.value, this.unit);
    }

    private static split(raw: string | number | null | undefined, unit?: string) {
        if (raw === null || raw === undefined || raw === '') {
            return { value: '—', unit: '' };
        }
        const text = String(raw).trim();
        if (unit) {
            return { value: text, unit };
        }
        const match = text.match(/^(-?[\d.,]+[kKMB]?)\s+(.+)$/);
        return match ? { value: match[1], unit: match[2] } : { value: text, unit: '' };
    }
}
